import React, { memo } from "react";
import {
  InputLabel,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { Typography } from "../Wrappers/Wrappers";
import useStyles from "./styles";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { withStyles } from "@mui/styles";

import { useI18n } from "../../providers/I18n/I18n";
import classNames from "classnames";
import Theme from "../../themes/theme.d";

interface IRadioButton {
  id: string;
  label?: string;
  required?: boolean;
  value?: any;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, value?: string) => void;
  options?: string[];
  optionValueKey?: string;
  optionLabelKey?: string;
  helperText?: string;
  customLabelStyle?: string;
  checkedColor?: string;
  customStyle?: string;
  customClass?: string;
  defaultValue?: any;
  testId?: any;
  disabled?: boolean;
  disableMargin?: boolean;
}

const RadioButton = ({
  id,
  value,
  label,
  required = false,
  onChange,
  options = [],
  optionLabelKey,
  optionValueKey,
  customLabelStyle,
  helperText,
  checkedColor,
  customStyle,
  defaultValue,
  testId,
  disabled = false,
}: IRadioButton) => {
  const classes = useStyles();
  const theme: Theme = useTheme();
  const { t } = useI18n();
  const StyledRadio = withStyles({
    root: {
      "&$checked": {
        color: theme.palette.UI.black,
      },
      "&.Mui-disabled": {
        color: theme.palette.UI.disabled, // greyed out circle
      },
      "&.Mui-disabled.Mui-checked": {
        color: theme.palette.UI.disabled, // greyed out checked circle
      },
    },
    checked: {},
  })((props) => <Radio color="default" {...props} />);

  return (
    <FormControl className={customStyle ? customStyle : classes.formControl}>
      {label && (
        <InputLabel shrink htmlFor={id} className={classes.radioLabel}>
          {label} {required && "*"}
          {helperText ? `(${helperText})` : ""}
        </InputLabel>
      )}
      <RadioGroup
        value={value}
        data-testid={id}
        className={classNames(classes.selectFluid, classes.radioMargin)}
        name={id}
        aria-label={id}
        onChange={onChange}
        defaultValue={defaultValue}
        id={id}
        data-test-id={testId ? testId : id}
      >
        {options.map((val, index) => (
          <FormControlLabel
            disabled={disabled}
            key={index}
            value={val}
            control={<StyledRadio data-testid={String(val).split(" ").join("_")} />}
            label={
              <Typography
                className={classNames(classes.formControlLabel, customLabelStyle)}
              >
                {t(val)}
              </Typography>
            }
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

RadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  optionValueKey: PropTypes.string,
  optionLabelKey: PropTypes.string,
  helperText: PropTypes.string,
};

export default memo(RadioButton);
